import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

// CDK
import { MatIconModule } from '@angular/material/icon';

// RxJs
import { filter, Observable } from 'rxjs';

// NgRX
import { Store } from '@ngrx/store';
import { AppState } from '@core/store/reducers';
import { selectSessionUserState } from '@core/store/selectors/session.selectors';
import { SessionEffectsActions } from '@core/store/actions/session.actions';

// Models
import { User } from '@core/models/session.interface';



@Component({
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    RouterModule,
    MatIconModule
  ],
  selector: 'rental-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarSComponent implements OnInit {

  public user!: Observable<User | null>;


  constructor(
    private readonly store: Store<AppState>,
  ) {
  }


  ngOnInit(): void {
    this.user = this.store.select(selectSessionUserState).pipe(
      filter(user => !!user?.role)
    );
  }


  public logOut(): void {
    this.store.dispatch(SessionEffectsActions.logOut());
  }


  public logIn(): void {
    this.store.dispatch(SessionEffectsActions.logIn());
  }
}
